// action types
import { createRequestTypes } from "../../utils";




// Scheduled Jobs
export const FETCH_SCHEDULED_JOBS = createRequestTypes("FETCH_SCHEDULED_JOBS");

export const fetchScheduledJobsRequest = () =>
    ({ type: FETCH_SCHEDULED_JOBS.REQUEST });

export const fetchScheduledJobsSuccess = (data) =>
    ({ type: FETCH_SCHEDULED_JOBS.SUCCESS, payload: { data } });

export const fetchScheduledJobsFailure = (error) =>
    ({ type: FETCH_SCHEDULED_JOBS.FAILURE, payload: error });

// Queued Jobs
export const FETCH_QUEUED_JOBS = createRequestTypes("FETCH_QUEUED_JOBS");

export const fetchQueuedJobsRequest = () =>
    ({ type: FETCH_QUEUED_JOBS.REQUEST });

export const fetchQueuedJobsSuccess = (data) =>
    ({ type: FETCH_QUEUED_JOBS.SUCCESS, payload: { data } });

export const fetchQueuedJobsFailure = (error) =>
    ({ type: FETCH_QUEUED_JOBS.FAILURE, payload: error });

// Running Jobs
export const FETCH_RUNNING_JOBS = createRequestTypes("FETCH_RUNNING_JOBS");

export const fetchRunningJobsRequest = () =>
    ({ type: FETCH_RUNNING_JOBS.REQUEST });

export const fetchRunningJobsSuccess = (data) =>
    ({ type: FETCH_RUNNING_JOBS.SUCCESS, payload: { data } });

export const fetchRunningJobsFailure = (error) =>
    ({ type: FETCH_RUNNING_JOBS.FAILURE, payload: error });

// Finished Jobs
export const FETCH_FINISHED_JOBS = createRequestTypes("FETCH_FINISHED_JOBS");

export const fetchFinishedJobsRequest = (limit = 100) =>
    ({ type: FETCH_FINISHED_JOBS.REQUEST, payload: { limit } });

export const fetchFinishedJobsSuccess = (data) =>
    ({ type: FETCH_FINISHED_JOBS.SUCCESS, payload: { data } });

export const fetchFinishedJobsFailure = (error) =>
    ({ type: FETCH_FINISHED_JOBS.FAILURE, payload: error });

// Failed Jobs
export const FETCH_FAILED_JOBS = createRequestTypes("FETCH_FAILED_JOBS");

export const fetchFailedJobsRequest = (limit = 100) =>
    ({ type: FETCH_FAILED_JOBS.REQUEST, payload: { limit } });

export const fetchFailedJobsSuccess = (data) =>
    ({ type: FETCH_FAILED_JOBS.SUCCESS, payload: { data } });

export const fetchFailedJobsFailure = (error) =>
    ({ type: FETCH_FAILED_JOBS.FAILURE, payload: error });

// Statistics
export const FETCH_STATISTICS = createRequestTypes("FETCH_STATISTICS");

export const fetchStatisticsRequest = () =>
    ({ type: FETCH_STATISTICS.REQUEST });

export const fetchStatisticsSuccess = (data) =>
    ({ type: FETCH_STATISTICS.SUCCESS, payload: { data } });

export const fetchStatisticsFailure = (error) =>
    ({ type: FETCH_STATISTICS.FAILURE, payload: error });

// Job Detail
export const FETCH_JOB_DETAIL = createRequestTypes("FETCH_JOB_DETAIL");

export const fetchJobDetailRequest = (job_id) =>
    ({ type: FETCH_JOB_DETAIL.REQUEST, payload: { job_id } });

export const fetchJobDetailSuccess = (data) =>
    ({ type: FETCH_JOB_DETAIL.SUCCESS, payload: { data } });

export const fetchJobDetailFailure = (error) =>
    ({ type: FETCH_JOB_DETAIL.FAILURE, payload: error });

// Remove Scheduled Job
export const REMOVE_SCHEDULED_JOB = createRequestTypes("REMOVE_SCHEDULED_JOB");

export const removeScheduledJobRequest = (job_id) =>
    ({ type: REMOVE_SCHEDULED_JOB.REQUEST, payload: { job_id } });

export const removeScheduledJobSuccess = (job_id) =>
    ({ type: REMOVE_SCHEDULED_JOB.SUCCESS, payload: { job_id } });

export const removeScheduledJobFailure = (error) =>
    ({ type: REMOVE_SCHEDULED_JOB.FAILURE, payload: error });

// Remove Job
export const REMOVE_JOB = createRequestTypes("REMOVE_JOB");

export const removeJobRequest = (job_id) =>
    ({ type: REMOVE_JOB.REQUEST, payload: { job_id } });

export const removeJobSuccess = (job_id) =>
    ({ type: REMOVE_JOB.SUCCESS, payload: { job_id } });

export const removeJobFailure = (error) =>
    ({ type: REMOVE_JOB.FAILURE, payload: error });

// Clear Finished Jobs
export const CLEAR_FINISHED_JOBS = createRequestTypes("CLEAR_FINISHED_JOBS");

export const clearFinishedJobsRequest = (older_than_hours) =>
    ({ type: CLEAR_FINISHED_JOBS.REQUEST, payload: { older_than_hours } });

export const clearFinishedJobsSuccess = (data) =>
    ({ type: CLEAR_FINISHED_JOBS.SUCCESS, payload: { data } });

export const clearFinishedJobsFailure = (error) =>
    ({ type: CLEAR_FINISHED_JOBS.FAILURE, payload: error });

// Clear Failed Jobs
export const CLEAR_FAILED_JOBS = createRequestTypes("CLEAR_FAILED_JOBS");

export const clearFailedJobsRequest = () =>
    ({ type: CLEAR_FAILED_JOBS.REQUEST });

export const clearFailedJobsSuccess = (data) =>
    ({ type: CLEAR_FAILED_JOBS.SUCCESS, payload: { data } });

export const clearFailedJobsFailure = (error) =>
    ({ type: CLEAR_FAILED_JOBS.FAILURE, payload: error });
